<template>
  <div class="cnt-info-root" v-if="user">
    <img class="img-banner" src="../../assets/b2b-img-refer-top-2x.png">
    <a class="txt-name"><b class="name">{{ user.first_name }}</b> just sent you an<br>invite to join StoreCash</a>
    <a v-if="user.referral_campaign.enabled" class="campaign-message">{{ user.referral_campaign.message }}</a>
    <a class="btn-install" :href="user.referral_link_firebase">Install App</a>
    <div v-if="user.referral_campaign.enabled" class="campaign-terms">
      <a class="title">TERMS & CONDITIONS{{"\n\n"}}</a>
      <div class="terms">{{ user.referral_campaign.terms }}</div>
    </div>
  </div>
</template>

<script>
import API from "../../modules/api";

export default {
  name: "b2b-view-info",

  data: function() {
    return {
      processing: false,
      user: null
    };
  },

  mounted: function() {
    const vm = this;
    vm.init();
  },

  methods: {
    // Fetch Details
    init: async function() {
      const vm = this;
      try {
        vm.processing = true;
        vm.user = await API.b2b.referral.getInfo(vm.$route.params.id);
      } catch (err) {
        // Todo
      } finally {
        vm.processing = false;
      }
    }
  }
};
</script>

<style lang="sass" scoped>

@import "../../assets/default.sass"

.cnt-info-root
  display: flex
  flex-direction: column
  justify-content: flex-start
  align-items: center
  width: 100%
  min-height: 90vh
  background: #FFFFFF

  .img-banner
    width: 100%
    height: auto

  .txt-name
    padding: 20px 40px 25px 40px
    width: 100%
    color: #434343
    font-size: 22px
    text-align: center

    .name
      text-transform: capitalize

  .campaign-message
    padding: 0px 40px 0px 40px
    width: 100%
    color: #95989A
    font-size: 16px
    text-align: center
    white-space: pre-line

  .campaign-terms
    padding: 0px 30px 30px 30px
    width: 100%
    display: flex
    flex-direction: column
    justify-content: flex-start

    .title
      color: #5D5D5D
      font-size: 11px
      font-weight: 800
      white-space: pre-line

    .terms
      color: #95989A
      font-size: 13px
      white-space: pre-line

  .btn-install
    cursor: pointer
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    margin: 30px 40px 50px 40px
    height: 40px
    width: 75%;
    color: #FFFFFF
    font-weight: 800;
    font-size: 20px;
    text-decoration: none
    background: linear-gradient(90deg, rgba(255,110,65,1) 0%, rgba(255,110,170,1));
    border: 0px solid
    border-radius: 20px
    box-shadow: 0 2px 2px 0 #DADADA

  .btn-install:hover
    box-shadow: 0 4px 4px 0 #DADADA

</style>
